import {TFilter, TList, TResponse} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';

import {get} from '../../http';

import {
  ENDPOINT_REF_PARTNER_TRX_COUNT,
  ENDPOINT_REF_PARTNER_STATS
} from '../../../constants/api';

export function apiV2ReferralTrxCountGet(params): Promise<TResponse> {
  const url = ENDPOINT_REF_PARTNER_TRX_COUNT;

  params = params || {};

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url, params);
}

export function apiV2ReferralStatsAndLinks(): Promise<TResponse> {
  const url = ENDPOINT_REF_PARTNER_STATS;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url);
}
